import { defineComponent as o, openBlock as r, createBlock as c, unref as n, mergeProps as l, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconCheckWithSparkles",
  __name: "IconCheckWithSparkles",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (s, e) => (r(), c(n(m), l(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M9 3.804a.75.75 0 0 1 .75.75c0 1.505.324 2.388.85 2.91.527.524 1.411.84 2.9.84a.75.75 0 0 1 0 1.5c-1.483 0-2.37.322-2.898.851-.53.53-.852 1.415-.852 2.899a.75.75 0 0 1-1.5 0c0-1.483-.325-2.37-.855-2.898-.53-.53-1.417-.852-2.895-.852a.75.75 0 0 1 0-1.5c1.483 0 2.369-.316 2.897-.84.527-.523.853-1.406.853-2.91A.75.75 0 0 1 9 3.804M8.999 7.84a3.7 3.7 0 0 1-1.222 1.22 3.74 3.74 0 0 1 1.222 1.225 3.7 3.7 0 0 1 1.22-1.225A3.7 3.7 0 0 1 9 7.84m11.53.283a.75.75 0 0 1 0 1.06L9.884 19.83a1.25 1.25 0 0 1-1.768 0L3.47 15.184a.75.75 0 0 1 1.06-1.06L9 18.592l10.47-10.47a.75.75 0 0 1 1.06 0m-2.03 7.181a.75.75 0 0 1 .75.75c0 .444.098.578.136.615.038.039.173.135.614.135a.75.75 0 1 1 0 1.5c-.436 0-.572.096-.613.137-.04.04-.137.177-.137.613a.75.75 0 0 1-1.5 0c0-.435-.097-.571-.138-.613-.042-.04-.178-.136-.612-.136a.75.75 0 0 1 0-1.5c.439 0 .574-.096.614-.135.038-.038.136-.172.136-.615a.75.75 0 0 1 .75-.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
